import { Box, Paragraph, Switch } from '@zillow/constellation-10';
import { useState } from 'react';
import { useCookies } from 'react-cookie';
import { ANALYTICS_V2_ENABLED_COOKIE, BETA_COOKIE } from '../constants';

export const NewVersionToggle = ({ text = 'Enable new analytics version' }: { text?: string }) => {
  const [cookies, setCookie] = useCookies([BETA_COOKIE, ANALYTICS_V2_ENABLED_COOKIE]);
  const [checked, setChecked] = useState(cookies.analyticsV2Enabled === 'true');
  return (
    <Box
      css={{
        position: 'fixed',
        bottom: '2400',
        left: '400',
        zIndex: 1500,
        backgroundColor: 'yellow.300',
        opacity: 0.5,
        _hover: { opacity: 1 },
        padding: '400',
        borderRadius: '200',
        transition: 'opacity 0.2s ease-in-out',
      }}
    >
      <Paragraph css={{ marginBottom: '200' }} textStyle="body-bold">
        {text}
      </Paragraph>
      <Switch
        checked={checked}
        onChange={() => {
          setChecked(!checked);
          setCookie(ANALYTICS_V2_ENABLED_COOKIE, !checked);
          setCookie(BETA_COOKIE, !checked);
          window.location.reload();
        }}
      />
    </Box>
  );
};
